import createLucideIcon from '../createLucideIcon';

const ArrowUpFromLine = createLucideIcon('ArrowUpFromLine', [
  ['line', { x1: '12', x2: '12', y1: '3', y2: '17', key: '1fslqe' }],
  ['polyline', { points: '18 9 12 3 6 9', key: '84brd3' }],
  ['path', { d: 'M5 21h14', key: '11awu3' }],
]);

export default ArrowUpFromLine;
